<template>
  <div>
    <p class="has-text-weight-bold is-size-4">{{ $t("mp:users.title") }}</p>

    <FieldListing
      :data="users"
      :columns="tableColumns"
      :actions="actions"
      :searchable="true"
      :paginated="true"
      store-fetch-command="users/fetchList"
      store-get-command="users/getList"
      :search-fields="searchFields"
    >
      <b-button
        v-if="canCreate"
        type="is-blue"
        @click="newUser"
        icon-left="plus"
        class="is-pulled-right"
      >
        {{ $t("mp:users.button.create") }}
      </b-button>
    </FieldListing>
  </div>
</template>

<script>
import FieldListing from "../components/FieldListing";
import { ROLES, SEARCH_FIELD_TYPES } from "../utils/const";
import { formatBooleanRow } from "../utils/util";
import { AUTHORITIES } from "../utils/authorities";

export default {
  name: "Users",
  title: "mp:page.users.title",
  components: {
    FieldListing,
  },
  async mounted() {
    await this.fetch();
    this.loaded = true;
  },
  data() {
    return {
      ROLES,
      users: [],
      searchFields: [
        {
          name: "mp:users.list_header.first_name",
          identifier: "firstName",
          type: SEARCH_FIELD_TYPES.TEXT,
          genericSearch: true,
        },
        {
          name: "mp:users.list_header.last_name",
          identifier: "lastName",
          type: SEARCH_FIELD_TYPES.TEXT,
          genericSearch: true,
        },
        {
          name: "mp:users.list_header.roles",
          identifier: "roles",
          type: SEARCH_FIELD_TYPES.TEXT,
          genericSearch: false,
        },
        {
          name: "mp:users.list_header.active",
          identifier: "active",
          type: SEARCH_FIELD_TYPES.BOOLEAN,
          genericSearch: false,
        },
        {
          name: "mp:users.list_header.locked",
          identifier: "locked",
          type: SEARCH_FIELD_TYPES.BOOLEAN,
          genericSearch: false,
        },
        {
          name: "mp:users.list_header.last_login",
          identifier: "lastLogin",
          type: SEARCH_FIELD_TYPES.DATETIME,
          genericSearch: false,
        },
      ],
      tableColumns: [
        {
          field: "lastName",
          label: "mp:users.list_header.name",
          format: (row) => {
            return row.lastName + " " + row.firstName;
          },
        },
        {
          field: "roles",
          label: "mp:users.list_header.roles",
          format: (row) => {
            return row.roles.length > 20
              ? row.roles.substring(0, 20).concat("...")
              : row.roles;
          },
        },
        {
          field: "lastLogin",
          label: "mp:users.list_header.last_login",
          format: (row) => {
            return this.$options.filters.dateTime(row.lastLogin);
          },
        },
        {
          field: "active",
          label: "mp:users.list_header.active",
          vhtml: true,
          format: (row) => {
            return formatBooleanRow(row.active);
          },
        },
        {
          field: "locked",
          label: "mp:users.list_header.locked",
          vhtml: true,
          format: (row) => {
            return formatBooleanRow(row.locked);
          },
        },
      ],
      actions: [
        {
          icon: "cog",
          iconPack: "fa",
          type: "is-blue",
          disabled: (row) => {
            return !this.canUpdate || row.roles.includes(ROLES.SUPER_ADMIN);
          },
          function: (row) => {
            if (row.id === this.$store.getters["session/userId"]) {
              this.$router.push({
                name: "Profile",
              });
            } else {
              this.$router.push({
                name: "User",
                params: {
                  id: row.id,
                },
              });
            }
          },
        },
      ],
    };
  },
  computed: {
    canCreate() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.USER.CREATE,
        AUTHORITIES.USER.ADMIN,
      ]);
    },
    canUpdate() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.USER.UPDATE,
        AUTHORITIES.USER.ADMIN,
      ]);
    },
  },
  methods: {
    newUser() {
      this.$router.push({
        name: "User",
      });
    },
  },
};
</script>
